<template>
    <table class="table table-hover table-bordered table-sm mt-1">
        <thead>
            <tr>
                <th scope="col">Id</th>
                <th scope="col">Nombre</th>
                <th scope="col">Configurar</th>
            </tr>
        </thead>
        <tbody>
            <admin-subzones-table-row 
                :item="subzone" v-for="subzone in rows" :key="subzone.id"
            />
            <tr>
                <td colspan="3" class="text-center">
                    <b-button
                        variant="light"
                        class="border"
                        @click="openAddSubzoneModal"
                    >
                        <i class="fa fa-plus-circle mr-2"></i>
                        <span>Añadir a {{pickupzone.name}}</span>
                    </b-button>
                    <admin-add-subzone-modal :pickupzone="pickupzone" />
                </td>
            </tr>
        </tbody>
    </table>

</template>

<script>
import AdminSubzonesTableRow from './AdminSubzonesTableRow'
import AdminAddSubzoneModal from './AdminAddSubzoneModal'

export default {
    components: {
        AdminSubzonesTableRow,
        AdminAddSubzoneModal,
    },
    props: {
        rows: {
            type: Array,
            required: true
        },
        pickupzone: {
            type: Object,
            required: true
        }
    },
    methods: {
        openAddSubzoneModal() {
            this.$bvModal.show("addSubzone_" + this.pickupzone.id);
        }
    },
    computed: {
        //pickupzone() {
        //    if ( this.rows != null && this.rows.length > 0 ) {
        //        return this.rows[0].pickup_zone
        //    }
        //    return 0
        //}
    }
}
</script>



<!-- <div class="mb-1">
                        <b-dropdown
                            size="lg"
                            variant="link"
                            toggle-class="text-decoration-none"
                            class="float-right"
                            no-caret
                        >
                            <template v-slot:button-content>
                                <i class="fa fa-ellipsis-v"></i>
                            </template>
                            <b-dropdown-item>
                                <div v-b-modal="'addSubzone'">
                                    <i class="fa fa-plus-circle mr-2 fa-fw"/> Nueva
                                </div>
                                <admin-add-subzone-modal :pickupzone="pickupzone" />
                            </b-dropdown-item>
                        </b-dropdown>
                    </div> -->